import React from 'react';
import { createRoot } from 'react-dom/client';

import Search from './components/Search/Search.jsx';

import { getProps, renderProps } from './utils/props.js';


const mountReactComponent = (selector, Component, name) => {
    document.querySelectorAll(selector).forEach((container) => {
        const props = getProps(container.dataset?.props)

        const root = createRoot(container);
        root.render(<Component {...renderProps(props)} />);
    });
};


mountReactComponent('.react-search', Search, 'Search');
